import React, { useContext, useState, useEffect, useRef } from 'react';
import EditText from '../crm/shared/field_inputs/text/EditText';
import EditDate from '../crm/shared/field_inputs/date/EditDate';
import { DataContext as ExlDataContext } from '../../stores/exl-store';
import { HandleAddCertificate } from './requests/CertificateRequests';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ExlCourseFormModal from './shared/ExlCourseFormModal';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import {
    ADD_CERTIFICATE_BUTTON_LABEL,
    ADD_CERTIFICATE_LABEL,
    CERTIFICATE_MODALS_INVALID_DATE_VALI,
    CERTIFICATE_MODALS_NAME_LABEL,
    CERTIFICATE_MODALS_DATE_LABEL,
    CERTIFICATE_MODALS_TAGS_LABEL,
    CERTIFICATE_MODALS_NO_NAME_VALI,
    CERTIFICATE_MODALS_TO_LONG_NAME_VALI,
} from '../../i18n/keyConstants';
import EditSelectMany from '../crm/shared/field_inputs/select_many/EditSelectMany';

let defaultFormValues = {};

const AddCertificate = ({ id }) => {
    id = decodeURIComponent(id);
    const { t } = useTranslation(['certificateModals']);

    const [defaultTemplate, setDefaultTemplate] = useState(defaultFormValues);

    let label = t(ADD_CERTIFICATE_BUTTON_LABEL);

    const clearForm = () => {
        defaultFormValues = {
            name: '',
        };
        setDefaultTemplate(defaultFormValues);
    };

    const { store: exlStore } = useContext(ExlDataContext);
    const tags = exlStore.certificateTags;

    const formComponents = [
        {
            propName: 'name',
            label: t(CERTIFICATE_MODALS_NAME_LABEL),
            validate: (v) =>
                !v || !v.length ? t(CERTIFICATE_MODALS_NO_NAME_VALI) : v.length > 60 ? t(CERTIFICATE_MODALS_TO_LONG_NAME_VALI) : '',
            component: <EditText />,
        },
        {
            propName: 'certificateDate',
            label: t(CERTIFICATE_MODALS_DATE_LABEL),
            validate: (v) => (!v ? t(CERTIFICATE_MODALS_INVALID_DATE_VALI) : ''),
            component: <EditDate />,
        },
        {
            propName: 'tags',
            label: t(CERTIFICATE_MODALS_TAGS_LABEL),
            validate: () => true,
            // component: <EditSelectMany values={[{ id: 1, name: 'test' }]} />,
            // component: <SelectManyInputContainer iconName='place' options={store.SkillOptions} />,
            component: (
                <EditSelectMany
                    label={t(CERTIFICATE_MODALS_TAGS_LABEL)}
                    icon='place'
                    initialValue={[]}
                    options={tags}
                    handleSave={(a, b, c) => console.log('hs-add', { a, b, c })}
                />
            ),
        },
    ];

    const handleAdd = async (certificate) => {
        console.log('handleAdd', { certificate });
        const response = await HandleAddCertificate({
            ...certificate,
            coaEmpId: id,
            createdDate: moment.utc(),
        });

        certificate = response.data;

        return response;
    };

    return (
        <ExlCourseFormModal
            label={label}
            description={t(ADD_CERTIFICATE_LABEL)}
            defaultFormValues={defaultTemplate}
            defaultFormComponents={formComponents}
            handleAdd={handleAdd}
            onSuccessiveSave={async () => {
                clearForm();
                window.location.reload();
            }}
            isExl
            handleCancel={clearForm}
            tooltipPlace={'left'}
            mailCalendarIconsEnabled={false}
        />
    );
};
export default AddCertificate;
